export default __webpack_public_path__ + "static/media/oh-you.46334e65.gif";